<div class="who-we-are-area">
    <div class="container">
        <div class="section-title">
            <h2>Nuestras líneas de <span>Investigación</span></h2>
            <p>
                En el Centro de Investigaciones en Desarrollo Humano, nos enfocamos en abordar de manera multidisciplinar diversos
                campos del conocimiento que representan nuestro compromiso con el conocimiento científico, la innovación y la transformación
                social.
            </p>
        </div>

        <div class="research-lines">
            <div class="single-who-we-are">
                <h4>Infancia y juventud</h4>
                <span>1</span>
            </div>
            <div class="single-who-we-are">
                <h4>Resiliencia al cambio climático, gestión del riesgo y comunidad</h4>
                <span>2</span>
            </div>
            <div class="single-who-we-are">
                <h4>Estudios de género, diversidad y ciudadanía</h4>
                <span>3</span>
            </div>
            <div class="single-who-we-are">
                <h4>Tecnología de la información y ciudadanía digital</h4>
                <span>4</span>
            </div>
            <div class="single-who-we-are">
                <h4>Psicología, comunicación, participación y construcción social de la salud</h4>
                <span>5</span>
            </div>
        </div>
    </div>
</div>
